export interface VideoItem {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  views: number;
  publishDate: string;
  description: string;
  content: string;
  tags: string[];
  author: string;
  hotScore: number;
}

export interface CategoryItem {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: CategoryItem[] = [
  { name: '全部', slug: 'all', icon: 'ri-global-line', count: 48 },
  { name: '明星吃瓜', slug: 'star-gossip', icon: 'ri-star-line', count: 15 },
  { name: '娱乐八卦', slug: 'entertainment', icon: 'ri-movie-2-line', count: 12 },
  { name: '社会热点', slug: 'social-hot', icon: 'ri-fire-line', count: 10 },
  { name: '综艺爆料', slug: 'variety-show', icon: 'ri-tv-2-line', count: 6 },
  { name: '网红动态', slug: 'influencer', icon: 'ri-user-smile-line', count: 5 },
];

export const videos: VideoItem[] = [
  {
    id: '1',
    title: '某顶流男星深夜密会神秘女子，两人同回公寓引热议',
    slug: 'top-star-secret-date',
    category: '明星吃瓜',
    categorySlug: 'star-gossip',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20paparazzi%20style%20night%20scene%20with%20two%20silhouettes%20walking%20into%20an%20apartment%20building%2C%20dramatic%20street%20lighting%2C%20cinematic%20mood%2C%20warm%20golden%20tones%2C%20mysterious%20atmosphere%2C%20clean%20minimal%20composition&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '05:32',
    views: 1285000,
    publishDate: '2026-08-05',
    description: '近日有媒体拍到某顶流男星深夜与一位神秘女子同行，两人举止亲密并一同返回公寓，引发网友热议。',
    content: '近日，有资深娱记拍到当红顶流男星李某在深夜结束工作后，并未直接返回住所，而是驱车前往某高档小区。随后一名身着黑色连衣裙的神秘女子上车，两人在车内交谈约20分钟后，一同进入公寓大楼。据目击者称，两人举止亲密，关系似乎不一般。\n\n此事一经曝光，立即在社交媒体引发轩然大波。李某的粉丝纷纷表态，有人表示"艺人也有私生活，请给予空间"，也有人质疑该神秘女子的身份。\n\n截至目前，李某工作室尚未对此事作出回应。不过有知情人士透露，该女子可能是李某新剧的制片人，两人疑似是在讨论工作事宜。\n\n更多后续进展，我们将持续关注。',
    tags: ['顶流明星', '恋情曝光', '深夜约会', '娱乐八卦'],
    author: '吃瓜小分队',
    hotScore: 98,
  },
  {
    id: '2',
    title: '热门综艺录制现场突发意外，导演组紧急叫停引猜测',
    slug: 'variety-show-accident',
    category: '综艺爆料',
    categorySlug: 'variety-show',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20TV%20studio%20set%20with%20bright%20stage%20lights%20and%20crew%20members%20gathered%20around%2C%20dramatic%20atmosphere%2C%20behind%20the%20scenes%20chaos%2C%20warm%20studio%20lighting%2C%20cinematic%20documentary%20style&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '03:18',
    views: 876200,
    publishDate: '2026-08-04',
    description: '某热门综艺节目在最新一期录制过程中突发意外状况，导演组当场叫停录制，现场气氛紧张，具体原因尚未公布。',
    content: '据了解，这档备受关注的热门综艺节目在最新一期录制时，因嘉宾之间发生激烈争执导致录制被迫中断。现场工作人员透露，两位常驻嘉宾在游戏环节因胜负问题产生矛盾，言辞激烈，气氛一度十分紧张。\n\n导演组见状紧急介入，暂停了录制进程，并将两位嘉宾分别带到休息室进行调解。经过约一小时沟通，两位嘉宾最终握手言和，录制才得以继续。\n\n节目组随后发布声明称："录制过程中出现的突发状况已妥善解决，感谢大家的关心，本期节目将如期播出，精彩内容敬请期待。"\n\n不过也有网友猜测，这可能是节目组为制造话题而刻意安排的情节。到底是真是假，只能等节目播出后才能揭晓了。',
    tags: ['综艺录制', '嘉宾争执', '突发事件', '综艺八卦'],
    author: '吃瓜小分队',
    hotScore: 85,
  },
  {
    id: '3',
    title: '知名女星深夜发文疑似回应婚变传闻，字字扎心',
    slug: 'actress-divorce-rumor',
    category: '明星吃瓜',
    categorySlug: 'star-gossip',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20social%20media%20post%20with%20emotional%20Chinese%20text%2C%20placed%20on%20a%20minimal%20desk%20with%20soft%20warm%20lighting%2C%20moody%20atmosphere%2C%20night%20vibe&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '04:55',
    views: 1534000,
    publishDate: '2026-08-05',
    description: '知名女演员张某凌晨在社交平台发布长文，字里行间满是心酸与无奈，网友纷纷猜测这是对近期婚变传闻的侧面回应。',
    content: '8月5日凌晨2点，知名女演员张某在其个人社交账号发布了一篇长文："人生就像一场戏，有些人注定只是过客。感谢曾经的美好，也感谢现在的清醒。愿各自安好。"这段文字虽未指名道姓，但字里行间流露出的情绪让人不禁将其与近期甚嚣尘上的婚变传闻联系起来。\n\n据悉，张某与丈夫已数月未在公开场合同框，丈夫近日更是被拍到与某年轻女性频繁出入同一小区。虽然双方工作室均未正式回应，但种种迹象似乎都在印证外界的猜测。\n\n张某的这条动态发布后，迅速登上热搜榜首。圈内好友纷纷留言安慰，粉丝也在评论区表达支持："姐姐要坚强！""你这么优秀，一定值得更好的！"\n\n目前，该动态已被转发超过50万次，评论数突破30万条。',
    tags: ['女明星', '婚变传闻', '深夜发文', '情感八卦'],
    author: '吃瓜小队长',
    hotScore: 96,
  },
  {
    id: '4',
    title: '某城市地铁发生乘客冲突事件，现场视频网络疯传',
    slug: 'subway-conflict-viral',
    category: '社会热点',
    categorySlug: 'social-hot',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20crowded%20subway%20train%20interior%20with%20passengers%20looking%20concerned%2C%20blurred%20figures%20in%20confrontation%2C%20warm%20subway%20lighting%2C%20documentary%20street%20photography%20style%2C%20realistic%20urban%20scene&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '02:08',
    views: 2350000,
    publishDate: '2026-08-06',
    description: '某城市地铁车厢内发生乘客冲突，现场视频在社交平台疯传。事件起因疑似座位争夺，最终演变为肢体冲突。',
    content: '8月6日早高峰时段，某一线城市地铁2号线车厢内发生一起乘客冲突事件。据目击者拍摄的视频显示，两名乘客因座位问题发生口角，随后矛盾升级为肢体冲突，现场一片混乱。\n\n视频中可以看到，争吵声和推搡动作引来了周围乘客的劝阻，有热心市民试图拉开双方，但冲突双方情绪激动，一度难以平息。\n\n地铁工作人员在下一站到站后迅速介入处理，将涉事双方带离车厢。所幸事件未造成人员严重受伤，也未对地铁运营造成重大影响。\n\n目前，当地警方已介入调查此事。地铁公司呼吁广大乘客文明出行，遇到矛盾时理性沟通，共同维护良好的乘车环境。',
    tags: ['地铁冲突', '社会热点', '公共秩序', '现场视频'],
    author: '热点追踪员',
    hotScore: 92,
  },
  {
    id: '5',
    title: '千万粉丝网红翻车！直播带货产品质量遭质疑',
    slug: 'influencer-livestream-scandal',
    category: '网红动态',
    categorySlug: 'influencer',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20livestream%20setup%20with%20ring%20light%20and%20products%20on%20display%2C%20dramatic%20lighting%20with%20warm%20tones%2C%20beauty%20products%20scattered%20on%20table%2C%20modern%20influencer%20studio%20aesthetic&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '06:45',
    views: 1890000,
    publishDate: '2026-08-04',
    description: '拥有千万粉丝的知名网红在最新直播带货中被质疑产品质量问题，大量消费者反映收到的商品与直播展示严重不符。',
    content: '近日，坐拥千万粉丝的头部网红"小美酱"在直播带货中推荐的一款护肤品引发广泛争议。多位消费者在收到产品后反映，实物与直播中展示的品质存在明显差异，使用后甚至出现皮肤过敏等不良反应。\n\n事件发酵后，越来越多的消费者站出来发声，要求退货退款。有网友将直播截图与实物进行对比，发现包装、质地、气味均存在出入，怀疑该网红在直播中使用的是"特供版"样品。\n\n面对质疑，"小美酱"在最新视频中回应称："所有产品均为正规渠道采购，如有质量问题可联系客服处理。"然而这一回应并未平息众怒，反而被网友吐槽态度敷衍。\n\n目前，相关监管部门已关注此事，消费者协会也表示将介入调查。网红带货行业的规范问题再次引发社会广泛讨论。',
    tags: ['网红翻车', '直播带货', '产品质量', '消费者维权'],
    author: '吃瓜小分队',
    hotScore: 90,
  },
  {
    id: '6',
    title: '娱乐圈最甜情侣官宣分手，五年感情终究散场',
    slug: 'celebrity-couple-breakup',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    thumbnail: 'https://readdy.ai/api/search-image?query=Two%20silhouettes%20walking%20apart%20on%20a%20rainy%20street%20at%20night%2C%20reflections%20on%20wet%20pavement%2C%20cinematic%20moody%20lighting%2C%20warm%20streetlamp%20glow%2C%20emotional%20atmosphere&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '04:20',
    views: 2110000,
    publishDate: '2026-08-03',
    description: '娱乐圈公认的"模范情侣"王某与陈某通过各自工作室同时发布声明，宣布两人已于近日和平分手，结束了长达五年的恋情。',
    content: '8月3日下午，演员王某与歌手陈某的工作室几乎在同一时间发布了分手声明，确认两人已结束恋人关系。声明中写道："感谢大家一直以来的关心与支持，经过慎重考虑，我们决定回归朋友关系。过去的五年是我们人生中最美好的时光之一，未来也会以朋友身份相互支持。"\n\n这对情侣自2021年公开恋情以来，一直被视为娱乐圈的"金童玉女"。两人不仅多次在综艺节目中大秀恩爱，还曾合作主演过热播剧集，CP粉遍布全网。\n\n消息传出后，#王某陈某分手# 的话题瞬间登上热搜第一，阅读量在短短一小时内突破5亿。粉丝们纷纷表示难以置信："我不信！""我的CP房子塌了！""五年的感情说散就散，太难过了。"\n\n有业内人士分析，两人分手可能与工作安排有关，长期聚少离多或许是主要原因。不过双方均表示，分手不涉及第三方，纯粹是感情自然走到了终点。',
    tags: ['明星情侣', '官宣分手', '五年感情', '娱乐圈'],
    author: '吃瓜小队长',
    hotScore: 99,
  },
  {
    id: '7',
    title: '某地惊现UFO目击事件，多名居民拍摄到不明飞行物',
    slug: 'ufo-sighting-viral',
    category: '社会热点',
    categorySlug: 'social-hot',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20night%20sky%20with%20mysterious%20glowing%20object%20hovering%20above%20a%20city%20skyline%2C%20multiple%20light%20trails%2C%20cinematic%20sci-fi%20atmosphere%2C%20warm%20city%20lights%20below%2C%20dramatic%20clouds&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '03:55',
    views: 3210000,
    publishDate: '2026-08-06',
    description: '某地多名居民在夜间拍摄到天空中出现了不明飞行物，视频迅速在社交平台引发热议，网友纷纷猜测是否为UFO。',
    content: '8月5日晚间，某地多位居民几乎在同一时间段目击并拍摄到了天空中出现的奇异光点。据目击者描述，该不明飞行物呈碟状，发出明亮的橙黄色光芒，在空中悬停约5分钟后，以极快的速度消失在天际。\n\n多位目击者将拍摄的视频上传至社交平台后，迅速引发全网关注。有天文爱好者分析认为，这可能是一种罕见的大气光学现象。也有网友打趣道："外星人也来吃瓜了吗？"\n\n当地气象部门回应称，当晚该区域天气晴朗，未监测到异常气象活动。民航部门则表示，当时该空域没有民航航班经过。\n\n截至目前，该不明飞行物的真实身份仍未得到官方确认。不过这一事件已经成功将"吃瓜"热度从娱乐圈延伸到了外太空。',
    tags: ['UFO', '不明飞行物', '目击事件', '社会热点'],
    author: '热点追踪员',
    hotScore: 95,
  },
  {
    id: '8',
    title: '某选秀节目选手黑幕曝光，导师评分被指造假',
    slug: 'talent-show-rigging',
    category: '综艺爆料',
    categorySlug: 'variety-show',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20talent%20show%20stage%20with%20bright%20spotlights%20and%20judges%20panel%2C%20dramatic%20theatrical%20lighting%2C%20warm%20golden%20stage%20glow%2C%20competitive%20atmosphere%2C%20professional%20studio%20photography&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '05:10',
    views: 1670000,
    publishDate: '2026-08-03',
    description: '某热门选秀节目被曝出评分造假丑闻，有知情人士透露节目组干预导师评分，以操控选手排名。',
    content: '近日，一位自称是该选秀节目前工作人员的网友在社交平台发布长文，揭露节目组存在严重的评分造假行为。据其爆料，节目组会在每轮比赛前与导师"沟通"，对某些选手的评分进行"微调"，以确保节目效果和话题度。\n\n该爆料者还晒出了多张疑似内部沟通截图，图片显示有工作人员向导师发送"建议分数"的消息。虽然截图真实性尚未得到证实，但已经引发了大量网友的讨论和质疑。\n\n节目组随后发布声明，坚决否认评分造假的指控，称所有评分均为导师独立判断，节目组从未进行任何干预。并表示将对造谣者保留法律追究权利。\n\n但有网友指出，此前几轮淘汰赛的结果确实存在诸多疑点，几位实力选手莫名其妙被淘汰，而某些表现平平的选手却一路晋级。这场风波恐怕不会轻易平息。',
    tags: ['选秀节目', '评分造假', '综艺黑幕', '选手争议'],
    author: '吃瓜小分队',
    hotScore: 88,
  },
  {
    id: '9',
    title: '某知名导演被曝片场耍大牌，工作人员集体吐槽',
    slug: 'director-diva-behavior',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20film%20set%20with%20director%20chair%20and%20camera%20equipment%2C%20crew%20members%20in%20background%2C%20behind%20the%20scenes%20movie%20production%2C%20warm%20cinematic%20lighting%2C%20professional%20film%20industry%20aesthetic&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '04:30',
    views: 945000,
    publishDate: '2026-08-02',
    description: '一位曾获得多项大奖的知名导演被多位剧组工作人员吐槽在片场态度恶劣，随意辱骂工作人员，引发行业热议。',
    content: '日前，一位自称在某知名导演新片剧组工作过的场务人员在社交平台发文，详细描述了该导演在片场的种种"恶行"。据其描述，这位导演经常因为一点小事就对工作人员大发雷霆，动辄骂人，甚至曾因一杯咖啡的温度不符合要求而将整杯咖啡泼在地上。\n\n该帖文发布后，迅速获得了大量转发。更令人意外的是，多位曾与该导演合作过的工作人员也在评论区现身说法，证实了这些爆料。有人表示："在他剧组干了一个月，瘦了十斤，不是累的，是气的。"\n\n截至目前，该导演本人尚未就此事作出回应。但有业内人士表示，在影视行业，导演在片场要求严格是常态，但尊重每一位工作人员同样是基本素养。\n\n这一事件再次引发了关于影视行业工作环境的讨论。',
    tags: ['导演耍大牌', '片场爆料', '影视行业', '工作环境'],
    author: '吃瓜小队长',
    hotScore: 78,
  },
  {
    id: '10',
    title: '某女星产后复出状态惊艳，被赞"最美辣妈"',
    slug: 'actress-postpartum-comeback',
    category: '明星吃瓜',
    categorySlug: 'star-gossip',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20beautiful%20elegant%20woman%20walking%20on%20red%20carpet%20in%20stunning%20gown%2C%20camera%20flashes%2C%20glamorous%20event%20atmosphere%2C%20warm%20golden%20lighting%2C%20fashion%20photography%20style&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '02:50',
    views: 789000,
    publishDate: '2026-08-05',
    description: '知名女演员赵某产后首次公开亮相，身材恢复惊人，状态极佳，被媒体和粉丝盛赞为"最美辣妈"。',
    content: '8月5日，知名女演员赵某出席了某奢侈品牌的新品发布会，这是她产后三个月的首次公开亮相。当天赵某一袭白色长裙惊艳全场，身材恢复得堪比产前，皮肤状态更是好到发光，丝毫看不出是刚生完宝宝的新手妈妈。\n\n现场媒体争相拍摄，赵某面对镜头笑容灿烂，状态轻松自然。在接受采访时她表示："当妈妈是人生中最美好的体验，虽然很累但看到宝宝的笑容一切都值得。"\n\n活动照片和视频发布后，#赵某产后状态# 迅速登上热搜，网友们纷纷惊叹："这哪像是刚生完孩子的人！""最美辣妈实至名归！""状态也太好了吧，求保养秘籍！"\n\n据悉，赵某目前已确认将出演一部都市情感剧，这也是她产后复出的首部作品。粉丝们已经迫不及待想要看到她的新作了。',
    tags: ['女星复出', '产后状态', '最美辣妈', '红毯造型'],
    author: '吃瓜小分队',
    hotScore: 82,
  },
  {
    id: '11',
    title: '某品牌代言人突然解约，背后原因引发众多猜测',
    slug: 'brand-ambassador-termination',
    category: '娱乐八卦',
    categorySlug: 'entertainment',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20luxury%20brand%20billboard%20being%20taken%20down%20in%20shopping%20district%2C%20workers%20on%20scaffolding%2C%20urban%20street%20scene%2C%20warm%20afternoon%20lighting%2C%20documentary%20style%20photography&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '03:40',
    views: 654000,
    publishDate: '2026-08-01',
    description: '某国际品牌在合约未到期的情况下突然宣布与代言人解约，品牌方仅以"战略调整"为由做出解释，引发业内诸多猜测。',
    content: '7月31日晚间，某国际知名品牌在其官方账号发布简短声明，宣布即日起终止与代言人刘某的合作关系。声明仅用"品牌战略调整"六个字解释了原因，对于解约的具体细节只字未提。\n\n这一突如其来的解约消息让外界大为惊讶。据悉，刘某与该品牌的代言合约原定还有一年才到期，且此前双方合作一直十分愉快，刘某还曾多次为该品牌拍摄广告大片。\n\n有业内人士分析认为，此次解约可能与刘某近期卷入的某争议事件有关。虽然该事件尚未被证实，但品牌方可能出于风险控制考虑做出了这一决定。\n\n刘某工作室随后发布声明称："尊重品牌方的决定，感谢过去三年愉快的合作。未来将继续专注于演艺事业，为大家带来更多优秀作品。"',
    tags: ['代言解约', '品牌合作', '明星代言', '娱乐八卦'],
    author: '吃瓜小队长',
    hotScore: 72,
  },
  {
    id: '12',
    title: '短视频平台新规出台，内容创作者迎来大洗牌',
    slug: 'short-video-platform-regulation',
    category: '社会热点',
    categorySlug: 'social-hot',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20short%20video%20app%20interface%20with%20notification%20banner%2C%20placed%20on%20minimal%20desk%20setup%2C%20modern%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%20clean%20composition&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '04:15',
    views: 1120000,
    publishDate: '2026-08-06',
    description: '国家相关部门发布短视频平台内容管理新规，对创作者资质、内容审核、收益分配等方面提出了更严格的要求。',
    content: '8月6日，国家互联网信息办公室联合相关部门发布了《短视频平台内容管理规范（修订版）》，对短视频行业提出了多项新要求。新规涉及创作者实名认证、内容分级审核、未成年保护、算法推荐透明化以及收益分配机制等多个方面。\n\n根据新规，粉丝量超过50万的创作者需要进行更严格的资质审核，内容发布前需经过平台双重审核机制。同时，平台需要对算法推荐逻辑进行公开说明，确保用户知情权。\n\n新规一出，短视频行业震动。有创作者表示欢迎："行业确实需要规范化了。"也有人担忧审核流程会影响内容发布的时效性。平台方面则纷纷表态将积极配合新规执行。\n\n业内专家分析认为，此次新规将加速短视频行业洗牌，低质内容和违规账号将被淘汰，优质创作者将获得更大的发展空间。',
    tags: ['短视频', '内容新规', '行业洗牌', '创作者'],
    author: '热点追踪员',
    hotScore: 86,
  },
  {
    id: '13',
    title: '某综艺节目嘉宾名单泄露，豪华阵容引期待',
    slug: 'variety-show-lineup-leak',
    category: '综艺爆料',
    categorySlug: 'variety-show',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20leaked%20document%20with%20celebrity%20names%20list%20on%20a%20table%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20tones%2C%20paparazzi%20style%20photography&width=800&height=450&seq=video-thumb-13&orientation=landscape',
    duration: '02:35',
    views: 756000,
    publishDate: '2026-08-05',
    description: '某即将开播的大型综艺节目疑似内部嘉宾名单被泄露，多位一线明星赫然在列，豪华阵容引发观众强烈期待。',
    content: '近日，一份据称是某卫视大型综艺节目《星光大道·巅峰对决》的嘉宾名单在网络上流传。名单中包括了多位娱乐圈一线明星和顶流艺人，阵容之豪华令网友直呼"太强了"。\n\n据泄露名单显示，节目将邀请到影帝级别演员、当红偶像团体成员、实力派歌手以及多位综艺感极佳的艺人。若名单属实，这将是今年阵容最强大的综艺节目之一。\n\n节目组随后发布声明，既未承认也未否认名单的真实性，仅表示："节目嘉宾阵容将在官方发布会上正式公布，请以官方信息为准。"这种模糊态度反而让网友更加确信名单的真实性。\n\n据悉，该节目预计将于8月底正式开播，目前正在紧锣密鼓地进行前期筹备工作。',
    tags: ['综艺节目', '嘉宾名单', '泄露', '豪华阵容'],
    author: '吃瓜小分队',
    hotScore: 80,
  },
  {
    id: '14',
    title: '网红城市打卡地出现踩踏隐患，官方紧急限流',
    slug: 'tourist-spot-stampede-risk',
    category: '社会热点',
    categorySlug: 'social-hot',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20crowded%20tourist%20spot%20in%20a%20Chinese%20city%20with%20large%20crowds%20and%20security%20barriers%2C%20warm%20sunset%20lighting%2C%20urban%20landscape%2C%20documentary%20style%2C%20realistic%20street%20photography&width=800&height=450&seq=video-thumb-14&orientation=landscape',
    duration: '03:05',
    views: 987000,
    publishDate: '2026-08-04',
    description: '某网红城市热门打卡地因游客爆满出现安全隐患，当地政府紧急发布限流措施，确保游客安全。',
    content: '随着暑期旅游旺季的到来，某网红城市的"天空之镜"打卡地迎来了客流高峰。8月4日下午，该景点瞬时游客量突破最大承载量，现场出现严重拥堵，存在踩踏风险。\n\n当地文旅部门接到报告后立即启动应急预案，对该景点实施临时限流措施，同时在周边增设了多个分流点。公安、消防、医疗等部门也迅速到场，确保现场秩序与游客安全。\n\n经过约两小时的疏导，景点秩序恢复正常。随后，当地政府发布公告，宣布该景点即日起实行预约限流制度，每日最大接待量不超过2万人次。\n\n这一事件也再次提醒广大游客，暑期出游一定要注意安全，避免扎堆前往热门景点。选择错峰出行，既能享受更好的旅游体验，也能确保自身安全。',
    tags: ['网红城市', '打卡地', '限流措施', '旅游安全'],
    author: '热点追踪员',
    hotScore: 76,
  },
  {
    id: '15',
    title: '某网红自曝整容失败经历，流泪讲述心酸往事',
    slug: 'influencer-plastic-surgery-failure',
    category: '网红动态',
    categorySlug: 'influencer',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20person%20sitting%20in%20front%20of%20mirror%20with%20dim%20lighting%2C%20emotional%20mood%2C%20warm%20but%20melancholic%20atmosphere%2C%20intimate%20portrait%20style%2C%20soft%20focus%20photography&width=800&height=450&seq=video-thumb-15&orientation=landscape',
    duration: '07:20',
    views: 1450000,
    publishDate: '2026-08-02',
    description: '一位拥有数百万粉丝的美妆网红在最新视频中坦诚分享了自己整容失败的经历，从满怀期待到术后噩梦的整个过程令人心疼。',
    content: '8月2日，美妆博主"小雨点"发布了一条时长7分钟的视频，在镜头前含泪讲述了自己整容失败的经历。据她介绍，两年前她在一家医美机构做了鼻部整形手术，但术后效果与预期严重不符，不仅鼻子形态不自然，还出现了呼吸困难的症状。\n\n"那段时间我几乎不出门，不敢照镜子，不敢面对自己的脸。"小雨点在视频中泣不成声。她表示，为了修复这个问题，她先后走访了多家医院，经历了两次修复手术，花费了巨额医疗费，至今仍未完全恢复。\n\n她希望通过分享自己的经历，提醒粉丝们在选择医美项目时一定要谨慎，选择正规机构和有资质的医生，不要为了一时冲动做出让自己后悔的决定。\n\n这条视频发布后获得了大量关注，许多网友在评论区分享了自己的类似经历，引发了关于医美行业规范化的广泛讨论。',
    tags: ['网红自曝', '整容失败', '医美行业', '心酸经历'],
    author: '吃瓜小队长',
    hotScore: 84,
  },
];

export const faqData = [
  {
    question: '吃瓜视频平台的内容多久更新一次？',
    answer: '我们平台每日实时更新，确保您不错过任何最新最热的吃瓜内容。编辑团队全天候追踪娱乐圈和社会热点，第一时间为您带来新鲜热辣的瓜事报道。',
  },
  {
    question: '如何快速找到我感兴趣的吃瓜内容？',
    answer: '您可以通过顶部的分类导航快速筛选不同类别的内容，包括明星吃瓜、娱乐八卦、社会热点、综艺爆料、网红动态等多个频道。同时，首页的热门推荐也会帮您发现当下最火的瓜事。',
  },
  {
    question: '吃瓜视频平台的内容来源是否可靠？',
    answer: '我们坚持从权威媒体和可靠渠道获取信息，所有内容都经过编辑团队的严格审核。虽然娱乐八卦内容本身具有不确定性，但我们力求在传播过程中保持客观公正，避免传播未经证实的虚假信息。',
  },
  {
    question: '可以在手机上看吃瓜视频吗？',
    answer: '当然可以！吃瓜视频平台采用响应式设计，完美适配手机、平板和电脑等多种设备。无论您身在何处，随时随地都能愉快吃瓜。',
  },
  {
    question: '如何向我们提供新闻线索或爆料？',
    answer: '如果您有独家爆料或新闻线索，欢迎通过「关于我们」页面的联系方式与我们取得联系。我们重视每一条用户反馈，对于有价值的线索，我们的编辑团队会第一时间跟进核实。',
  },
  {
    question: '吃瓜视频平台是否需要注册账号？',
    answer: '目前吃瓜视频平台完全免费开放，无需注册即可浏览全部内容。我们致力于让每一位用户无障碍地享受吃瓜的乐趣。',
  },
];

export const testimonials = [
  {
    name: '小明同学',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20person%20portrait%20with%20friendly%20smile%2C%20casual%20style%2C%20minimal%20studio%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-testimonial-01&orientation=squarish',
    comment: '每天打开吃瓜视频已经成了我的习惯！更新速度超快，内容也很有意思，再也不用到处找瓜吃了！',
    role: '忠实用户 · 使用1年',
  },
  {
    name: '娱乐达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20trendy%20young%20Chinese%20woman%20portrait%20with%20confident%20expression%2C%20modern%20style%2C%20minimal%20studio%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-testimonial-02&orientation=squarish',
    comment: '分类做得很好，想看什么类型的瓜都能快速找到。明星吃瓜频道是我的最爱，每次都有惊喜！',
    role: '娱乐博主 · 使用8个月',
  },
  {
    name: '吃瓜群众老李',
    avatar: 'https://readdy.ai/api/search-image?query=A%20middle%20aged%20Chinese%20man%20portrait%20with%20warm%20smile%2C%20casual%20professional%20style%2C%20minimal%20studio%20background%2C%20warm%20lighting%2C%20professional%20headshot&width=100&height=100&seq=avatar-testimonial-03&orientation=squarish',
    comment: '内容质量不错，不只是简单的标题党，每篇文章都有料。社会热点板块也做得很好，不止于娱乐。',
    role: '媒体从业者 · 使用6个月',
  },
];